import { Typography } from '@mui/material'
import { FlexGrowCol, FlexRow, useAsyncEffect } from '@xylabs/sdk-react'
import { WorldEngineStatsJson } from '@xyo-network/sdk-xyoworld-js'
import numeral from 'numeral'
import { useState } from 'react'
import { Helmet } from 'react-helmet'

import { useApi } from '../../Contexts'
import { Property } from '../../Properties'
import WorldBasePage from '../WorldBasePage'

const RewardsPage: React.FC = () => {
  const api = useApi()
  const [stats, setStats] = useState<WorldEngineStatsJson>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (mounted) => {
      if (api) {
        const stats = await api.engineStats.get()
        if (mounted()) {
          setStats(stats)
        }
      }
    },
    [api],
  )

  return (
    <WorldBasePage>
      <Helmet title="Application Settings" />
      <FlexGrowCol marginY={1} justifyContent="flex-start" alignItems="stretch">
        <FlexRow marginX={1}>
          <Typography variant="h1" align="center">
            Global COIN Reward Stats for XYO World
          </Typography>
        </FlexRow>
        <Property
          maxTitleWidth={240}
          title="COIN Total"
          value={
            stats?.pools?.coin?.discovered !== undefined && stats?.pools?.coin?.undiscovered !== undefined
              ? numeral(stats?.pools?.coin?.discovered + stats?.pools?.coin?.undiscovered).format('0,0[.]00')
              : undefined
          }
          tip={'Total COIN available in XYO World for rewards'}
        />
        <Property
          maxTitleWidth={240}
          title="COIN Undiscovered"
          value={stats?.pools?.coin?.undiscovered !== undefined ? numeral(stats?.pools?.coin?.undiscovered).format('0,0[.]00') : undefined}
          tip={'Total COIN not yet discovered with the Assay feature'}
        />
        <Property
          maxTitleWidth={240}
          title="COIN Discovered"
          value={stats?.pools?.coin?.discovered !== undefined ? numeral(stats?.pools?.coin?.discovered).format('0,0[.]00') : undefined}
          tip={'Total COIN discovered with the Assay feature'}
        />
        <Property
          maxTitleWidth={240}
          title="COIN Collected"
          value={stats?.pools?.coin?.collected !== undefined ? numeral(stats?.pools?.coin?.collected).format('0,0[.]00') : undefined}
          tip={'Total COIN collected in XYO World'}
        />
      </FlexGrowCol>
    </WorldBasePage>
  )
}

export default RewardsPage
